// Shorten string without cutting words
// https://stackoverflow.com/a/5454297/13041484
export const shorten = (
  str: string,
  maxLen: number,
  separator = ' '
): string => {
  if (!str || str.length <= maxLen) return str;
  return `${str.substr(0, str.lastIndexOf(separator, maxLen))}...`;
};
